import { render, staticRenderFns } from "./RenameProjectDialog.vue?vue&type=template&id=183c5e7d&scoped=true"
import script from "./RenameProjectDialog.vue?vue&type=script&lang=js"
export * from "./RenameProjectDialog.vue?vue&type=script&lang=js"
import style0 from "./RenameProjectDialog.vue?vue&type=style&index=0&id=183c5e7d&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "183c5e7d",
  null
  
)

export default component.exports